import { Box, Stack } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { UnstyledLink } from "Components/Routes/UnstyledLink";

type RuleLink = {
  url: string;
  title: string;
};

type Props = {
  links: Array<RuleLink>;
};

export const RulesLink = ({ links }: Props) => (
  <Stack gap={1} justifyContent="center" alignItems="center">
    {links.map(({ url, title }) => (
      <UnstyledLink key={url} to={url} target="_blank" rel="noreferrer">
        <Box
          component="span"
          display="flex"
          alignItems="center"
          gap={1}
          fontSize="0.875rem"
        >
          <LinkIcon />
          {title}
        </Box>
      </UnstyledLink>
    ))}
  </Stack>
);
